import { PageTitle } from "@/components/shared/title/page-title";
import { Vendors } from "./VendorsPage";
import { VendorsProvider } from "./context/VendorsContext";

const VendorsPage = () => {
	return (
		<>
			<PageTitle title="Vendors Management" />
			<VendorsProvider>
				<Vendors />
			</VendorsProvider>
		</>
	);
};

export default VendorsPage;
